var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateFd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82.23 95.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-24{fill:#fff;}.cls-1,.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-2,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-3,.cls-30,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2{fill:#0e48c6;}.cls-3{fill:#ade4fc;}.cls-4{fill:#0089ed;}.cls-5{fill:#042613;}.cls-6{fill:#074222;}.cls-7{fill:#249f5a;}.cls-8{fill:#33ba71;}.cls-9{fill:#e6e6e6;}.cls-10{fill:#b3b3b3;}.cls-11{fill:#2461ab;}.cls-12,.cls-28,.cls-31{fill:none;}.cls-12{stroke:#034587;stroke-width:0.5px;}.cls-13{fill:#808184;}.cls-14{fill:#d09800;}.cls-15{fill:#f2dc35;}.cls-16{fill:#d4a100;}.cls-17{fill:#f3df4d;}.cls-18{fill:#cb8e00;}.cls-19{opacity:0.12;}.cls-20{mask:url(#mask);}.cls-21{mask:url(#mask-2);}.cls-22{fill:#48b3ff;}.cls-23{fill:#0071cb;}.cls-24{opacity:0.5;}.cls-24,.cls-28,.cls-29{isolation:isolate;}.cls-25{fill:#f9d523;}.cls-26{fill:#d8aa20;}.cls-27{fill:#f7e143;}.cls-28{stroke:#d8aa20;stroke-width:1.23px;opacity:0.6;}.cls-29{fill:#49b2ff;opacity:0.4;}.cls-30{fill:#d2a912;}.cls-31{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.64px;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 15.95,
    y: 93.44,
    width: 6.14,
    height: 1.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix_b",
    "data-name": "prefix  b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix_a",
    "data-name": "prefix  a",
    className: "cls-1",
    d: "M16,93.44v1.63h6.14V93.44Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 16.04,
    y: 90.05,
    width: 4.79,
    height: 4.79,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix_d",
    "data-name": "prefix  d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix_c",
    "data-name": "prefix  c",
    className: "cls-1",
    d: "M20.83,90.05v4.78H16V90.05Z"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,91.8H56v-.41H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.27,82H58.09V10.39H21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.82,6.3h5.31a3.6,3.6,0,0,1,3.28,3.85l-.08,75.33A3.61,3.61,0,0,1,60,89.35H56.17L57.9,10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.73,91.69H5a.45.45,0,0,1-.46-.45V85.75A.46.46,0,0,1,5,85.29H18.73a.47.47,0,0,1,.46.46v5.49a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.73,91.12H5a.46.46,0,0,1-.46-.46V85.17A.45.45,0,0,1,5,84.72H18.73a.46.46,0,0,1,.46.45v5.49a.46.46,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.73,90.43H5A.46.46,0,0,1,4.5,90V84.48A.45.45,0,0,1,5,84H18.73a.46.46,0,0,1,.46.45V90a.46.46,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.73,89.85H5a.45.45,0,0,1-.46-.46V83.91A.45.45,0,0,1,5,83.45H18.73a.46.46,0,0,1,.46.46v5.48a.46.46,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.73,89.22H5a.45.45,0,0,1-.46-.45V83.28A.46.46,0,0,1,5,82.82H18.73a.47.47,0,0,1,.46.46v5.49a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18.73,88.65H5a.46.46,0,0,1-.46-.46V82.71A.45.45,0,0,1,5,82.25H18.73a.46.46,0,0,1,.46.46v5.48a.46.46,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.73,89.26H5a.46.46,0,0,1-.46-.46V83.31A.45.45,0,0,1,5,82.86H18.73a.46.46,0,0,1,.46.45V88.8a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.73,88.68H5a.45.45,0,0,1-.46-.46V82.74A.45.45,0,0,1,5,82.28H18.73a.46.46,0,0,1,.46.46v5.48a.45.45,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.73,87.92H5a.46.46,0,0,1-.46-.46V82A.45.45,0,0,1,5,81.52H18.73a.46.46,0,0,1,.46.45v5.49a.46.46,0,0,1-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.73,87.34H5a.45.45,0,0,1-.46-.45V81.4A.46.46,0,0,1,5,80.94H18.73a.47.47,0,0,1,.46.46v5.49a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.73,86.65H5a.45.45,0,0,1-.46-.45V80.71A.46.46,0,0,1,5,80.25H18.73a.47.47,0,0,1,.46.46V86.2a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.73,86.08H5a.46.46,0,0,1-.46-.46V80.13A.45.45,0,0,1,5,79.68H18.73a.46.46,0,0,1,.46.45v5.49a.45.45,0,0,1-.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.51,85.3H7.18a.9.9,0,0,0-.9-.9v-3a.9.9,0,0,0,.9-.91h9.33a.9.9,0,0,0,.9.91v3a.9.9,0,0,0-.9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.27,86.65H9.06V79.73a.34.34,0,0,1,.35-.35h5.52a.35.35,0,0,1,.35.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15.12,92H9.21a.16.16,0,0,1-.15-.16v-5.2h6.21v5.2a.16.16,0,0,1-.15.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M12.64,81.88s0,0,0,.05,0,.09,0,.13,0,0,0,0h-.31a.51.51,0,0,1,.07.17s0,0,0,0h.21s0,0,0,.06v.11s0,.06,0,.06h-.2s0,0,0,0a.5.5,0,0,1-.14.27.53.53,0,0,1-.2.13l-.18,0h0l.18.2.18.21.24.29h0s0,.07,0,.08h-.25l-.07,0c-.05-.06-.09-.12-.14-.17l-.12-.15-.21-.24-.19-.2s0,0,0,0V82.8s0-.06,0-.06h.14a.66.66,0,0,0,.24,0,.42.42,0,0,0,.15-.11.3.3,0,0,0,0-.08H11.5s0,0,0,0v-.15s0,0,0,0h.55a.22.22,0,0,0-.13-.1.45.45,0,0,0-.2,0h-.21s0,0,0-.06v-.15a.05.05,0,0,1,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M9.77,91.6h4.74V80.45H9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M13.73,80.51c0,.55-1.62,1-3.61,1s-3.6-.44-3.6-1,1.61-1,3.6-1,3.61.44,3.61,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12.25,79.76c0,.6-1.35,1.1-3,1.1s-3-.49-3-1.1v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12.25,79.05c0,.61-1.35,1.1-3,1.1s-3-.49-3-1.1S7.57,78,9.23,78s3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12,78.66c0,.61-1.34,1.1-3,1.1s-3-.49-3-1.1v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12,78c0,.6-1.34,1.09-3,1.09S6,78.56,6,78s1.35-1.1,3-1.1,3,.49,3,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12.25,77.45c0,.61-1.35,1.1-3,1.1s-3-.49-3-1.1v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12.25,76.75c0,.6-1.35,1.09-3,1.09s-3-.49-3-1.09,1.35-1.1,3-1.1,3,.49,3,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12,76.38c0,.61-1.34,1.1-3,1.1S6,77,6,76.38v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12,75.67c0,.61-1.34,1.1-3,1.1s-3-.49-3-1.1,1.35-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12.25,75.4c0,.6-1.35,1.09-3,1.09s-3-.49-3-1.09v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12.25,74.69c0,.61-1.35,1.1-3,1.1s-3-.49-3-1.1,1.35-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M11.84,74.19c0,.6-1.35,1.09-3,1.09s-3-.49-3-1.09V73.6h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M11.84,73.48c0,.61-1.35,1.1-3,1.1s-3-.49-3-1.1,1.35-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M11.84,72.74c0,.6-1.35,1.09-3,1.09s-3-.49-3-1.09v-.59h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M11.84,72c0,.61-1.35,1.1-3,1.1s-3-.49-3-1.1,1.35-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.08,71.91l-.94-.55H9.06l-.12.07s0,0,0,.06l.16.1a.4.4,0,0,1,.14.11.09.09,0,0,1,0,.11h0l-.43-.25H8.74l-.12.06a0,0,0,0,0,0,0h0l.45.26h0L9,72a.47.47,0,0,1-.21,0,.7.7,0,0,1-.23-.1l-.08,0,0,0a.06.06,0,0,0-.08,0l-.13.07s0,0,0,0,0,.12,0,.18a1.49,1.49,0,0,1,0,.21l0,.13a.77.77,0,0,1,0,.15.05.05,0,0,0,0,0l.21.12s.08,0,.08,0h0l0-.26a1.1,1.1,0,0,0,0-.18c0-.06,0-.12,0-.18h0l.19.07a1.24,1.24,0,0,0,.27,0,1.14,1.14,0,0,0,.33-.06,0,0,0,0,1,0,0l.17.09a.06.06,0,0,0,.08,0l.1,0s0,0,0-.05L9.55,72s0,0,0,0a.19.19,0,0,0,.07-.11h0l.23.13H10l.11-.06s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M18.88,92.15c0,.6-1.34,1.09-3,1.09s-3-.49-3-1.09v-.59h6v.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.88,91.45c0,.6-1.34,1.09-3,1.09s-3-.49-3-1.09,1.34-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M18.88,90.71c0,.6-1.34,1.09-3,1.09s-3-.49-3-1.09v-.59h6v.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.88,90c0,.6-1.34,1.09-3,1.09s-3-.49-3-1.09,1.34-1.09,3-1.09,3,.49,3,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M20.47,92.3a2.4,2.4,0,1,0-2.4,2.4,2.4,2.4,0,0,0,2.4-2.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M22.09,94.25c0,.46-1.37.82-3.07.82S16,94.71,16,94.25s1.38-.81,3.07-.81,3.07.36,3.07.81"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20.83,92.44a2.4,2.4,0,1,0-2.4,2.39,2.4,2.4,0,0,0,2.4-2.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.13,91.56a.07.07,0,0,1,0,.07v.16a0,0,0,0,1,0,0h-.39a.4.4,0,0,1,.09.2s0,0,0,0h.25c.05,0,.06,0,.06.07v.14s0,.07-.06.07h-.25s0,0,0,0a.62.62,0,0,1-.17.33.78.78,0,0,1-.24.16l-.23,0h0l.22.24.22.26.3.36h0s0,.08,0,.1H18.6a.16.16,0,0,1-.09,0l-.17-.21-.15-.18c-.09-.1-.17-.2-.26-.29s-.15-.17-.22-.25,0,0,0-.05v-.19a.05.05,0,0,1,.06-.06h.17a.76.76,0,0,0,.3,0,.4.4,0,0,0,.18-.13.31.31,0,0,0,.05-.1h-.72a.07.07,0,0,1,0,0v-.18s0,0,0,0h.68v0a.4.4,0,0,0-.16-.13.73.73,0,0,0-.25,0h-.26s-.06,0-.06-.08v-.18a.07.07,0,0,1,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.84,16.2l-.07,62.11-34.65,0,.07-66.55v4.43Zm5.34-1.5v-4A4.25,4.25,0,0,0,58,6.34l-37,0a4.25,4.25,0,0,0-4.15,4.35L16.77,85a4.25,4.25,0,0,0,4.14,4.36l37.05,0A4.26,4.26,0,0,0,62.11,85l.06-64.59v-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.54,83.82a2.66,2.66,0,1,0-2.66,2.66,2.65,2.65,0,0,0,2.66-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.73,46.19A10.84,10.84,0,1,0,39.89,57,10.84,10.84,0,0,0,50.73,46.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M45,46.19a5.52,5.52,0,1,0-5.52,5.52A5.53,5.53,0,0,0,45,46.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M41.32,46.19A1.84,1.84,0,1,0,39.48,48a1.84,1.84,0,0,0,1.84-1.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M39.68,39.44h1.23V38.21H39.68ZM47,47.21h1.23V46H47Zm-15.54,0h1.23V46H31.5ZM39.27,55H40.5V53.76H39.27ZM45,41.89h1.23V40.66H45Zm-11.46-.41h1.23V40.26H33.54ZM45,52.12h1.23V50.89H45Zm-11,.41h1.22V51.3H34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M35.61,46H35.5a.41.41,0,0,1-.3-.51,5,5,0,0,1,4.87-3.57.42.42,0,1,1,0,.83,4.15,4.15,0,0,0-4,3,.43.43,0,0,1-.42.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.23,69.71h2.45V67.25H28.23Zm7,0h2.46V67.25H35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M70,91H82.23v-.41H70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.28,12.44H34.13a.61.61,0,0,1-.59-.62.6.6,0,0,1,.59-.61H47.28a.59.59,0,0,1,.58.61.6.6,0,0,1-.58.62M31.5,12a.82.82,0,1,0-.82.82A.82.82,0,0,0,31.5,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M78.14,61.61S47.3,63.84,59.76,95.48c0,0-2.09-1.18-4.94-3.16A28.51,28.51,0,0,1,44.77,81C42.49,76.18,41,68.8,41.38,61.61c0,0,14-5.9,18.38-9.9,0,0,9.62,6.95,18.38,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.31,51.3a70.6,70.6,0,0,0,18.87,10c0,23.48-10.64,29.05-19.32,34.61C52.18,90.33,43,85.48,43,62c6.4-2.33,12.55-6.24,18.35-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M59.73,51.71a68.21,68.21,0,0,0,18.41,9.9c0,23.3-9.71,28.35-18.41,33.87C51,90,41.32,84.91,41.32,61.61a68.21,68.21,0,0,0,18.41-9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M59.73,54.57a60.34,60.34,0,0,0,16.36,8.79c0,20.69-8.63,25.18-16.36,30.08C52,88.54,43.36,84.05,43.36,63.36A60.54,60.54,0,0,0,59.73,54.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 36.45,
    cy: 1.35,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 13.05,
    cy: 1.35,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 9.45,
    cy: 19.93,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M67.09,72.78a7.57,7.57,0,1,0-7.57,7.57,7.57,7.57,0,0,0,7.57-7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M55.64,73.81l1.74,2,5.21-5.73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFd);
export default __webpack_public_path__ + "static/media/CorporateFD.16e8be5bfc9abd9a3dbbc75e30492df7.svg";
export { ForwardRef as ReactComponent };